import { css } from '@emotion/css';
import React from 'react';
import '@grafana/data';
import { useStyles2, ReactUtils, Tooltip, Icon, Space, Field } from '@grafana/ui';

const EditorField = (props) => {
  var _a;
  const { label, optional, tooltip, tooltipInteractive, children, width, ...fieldProps } = props;
  const styles = useStyles2(getStyles, width);
  const childInputId = (fieldProps == null ? undefined : fieldProps.htmlFor) || ((_a = ReactUtils) == null ? undefined : _a.getChildId(children));
  const labelEl = /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("label", { className: styles.label, htmlFor: childInputId }, label, optional && /* @__PURE__ */ React.createElement("span", { className: styles.optional }, " - optional"), tooltip && /* @__PURE__ */ React.createElement(Tooltip, { placement: "top", content: tooltip, theme: "info", interactive: tooltipInteractive }, /* @__PURE__ */ React.createElement(Icon, { tabIndex: 0, name: "info-circle", size: "sm", className: styles.icon }))), /* @__PURE__ */ React.createElement(Space, { v: 0.5 }));
  return /* @__PURE__ */ React.createElement("div", { className: styles.root }, /* @__PURE__ */ React.createElement(Field, { className: styles.field, label: labelEl, ...fieldProps }, children));
};
const getStyles = (theme, width) => {
  return {
    root: css({
      minWidth: theme.spacing(width != null ? width : 0)
    }),
    label: css({
      fontSize: 12,
      fontWeight: theme.typography.fontWeightMedium
    }),
    optional: css({
      fontStyle: "italic",
      color: theme.colors.text.secondary
    }),
    field: css({
      marginBottom: 0
      // GrafanaUI/Field has a bottom margin which we must remove
    }),
    icon: css({
      color: theme.colors.text.secondary,
      marginLeft: theme.spacing(1),
      ":hover": {
        color: theme.colors.text.primary
      }
    })
  };
};

export { EditorField };
//# sourceMappingURL=EditorField.js.map
